import { render, staticRenderFns } from "./InputPostcode.vue?vue&type=template&id=1406c31c&scoped=true&"
import script from "./InputPostcode.vue?vue&type=script&lang=ts&"
export * from "./InputPostcode.vue?vue&type=script&lang=ts&"
import style0 from "./InputPostcode.vue?vue&type=style&index=0&id=1406c31c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1406c31c",
  null
  
)

export default component.exports